// components/Training.jsx
import React, { Component } from "react";
import { Button, Spinner } from "@blueprintjs/core";
import { BASE_API } from "../../utils/constants";      // ← ai deja acest export
import "../../css/Training.scss";
import { withRouterParams } from "../../utils/withRouterParams";
import PlayersSidebar from "./PlayersSidebar";
import PlayersStatusRow from './PlayersStatusRow'
import Field from "./Field";
import SaveBar from "../../components-fm/SaveBar";

class Training extends Component {
    state = {
        sidebarOpen: true,
        collapsed: {
            active: true,   // sub 968px toate true by default
            injured: true,
            absent: true,
            excused: true,
            unselected: true,
        },
        players: [],
        loading: false,
        error: null,
        formation: '4-3-3',
        isSaveEnable: false
    };

    /* ───────────── API CALL ───────────── */
    componentDidMount() {
        const wrapper = document.getElementById('echipaDashboard');
        if (wrapper) {
            wrapper.classList.add('layout-xl-width');
        }
        if (window.innerWidth < 968) {
            this.setState({
                sidebarOpen: true,               // sidebar e vizibil, dar redus
                collapsed: { active: true, injured: true, excused: true }
            });
        }
        const params = new URLSearchParams(this.props.location);
        this.loadPlayers();
    }

    componentWillUnmount() {
        const wrapper = document.getElementById('echipaDashboard');
        if (wrapper) {
            wrapper.classList.remove('layout-xl-width');
        }
    }

    async loadPlayers() {
        const { teamId } = this.props;                     // <-- trece-l din parent
        if (!teamId) {
            this.setState({ error: "teamId lipsă în props" });
            return;
        }

        this.setState({ loading: true });
        try {
            const res = await fetch(`${BASE_API}/api/team-players/${teamId}`);
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Eroare la jucători");

            this.setState({ players: json.players ?? [], loading: false });
        } catch (err) {
            this.setState({ error: err.message, loading: false });
        }
    }

    /* ───────────── UI helpers ───────────── */
    toggleSidebar = () => this.setState(prev => ({ sidebarOpen: !prev.sidebarOpen }));


    /* toggle individual collapse */
    toggleSection = key =>
        this.setState(prev => ({
            collapsed: { ...prev.collapsed, [key]: !prev.collapsed[key] }
        }));

    handleStatusChange = async (playerId, newStatus) => {
        console.log(playerId, newStatus)
        const { players } = this.state;
        // const { trainingId } = this.props; // trebuie transmis din parent

        // // Update local state
        const updated = players.map(p =>
            p.id === playerId ? { ...p, status: newStatus } : p
        );
        this.setState({ players: updated, isSaveEnable: true });
    };

    /* ───────────── RENDER ───────────── */
    render() {
        console.log('Training ....')
        const { sidebarOpen, collapsed, players, loading, error, system, formation } = this.state;
        return (
            <div
                className={`training-page field-container ${sidebarOpen ? "sidebar-open" : "sidebar-closed"
                    }`}
            >
                <PlayersSidebar
                    players={players}
                    loading={loading}
                    error={error}
                    sidebarOpen={sidebarOpen}
                    collapsed={collapsed}
                    onToggleAll={this.toggleSidebar}
                    onToggleColl={this.toggleSection}
                    onChangeStatus={this.handleStatusChange}
                />

                <div className="training-players-col">
                    <PlayersStatusRow
                        players={players}
                        loading={loading}
                        error={error}
                        sidebarOpen={sidebarOpen}
                        collapsed={collapsed}
                        onToggleColl={this.toggleSection}
                        onChangeStatus={this.handleStatusChange}
                     />
                     
                    <Field players={players.filter(p => (p.status === 'active' || !p.status))} formation={formation} />
                </div>

                <SaveBar
                    visible={this.state.isSaveEnable}
                    onSave={() => console.log("Save pressed")}   // TODO: Replace with real save
                    onCancel={() => {
                        // TODO: Reîncarcă jucătorii (resetează modificările)
                        this.loadPlayers();
                        this.setState({ isSaveEnable: false });
                    }}
                />

            </div>
        );
    }
}


export default withRouterParams(Training);

